import axios from "../utils/axios";
import React, { useEffect, useState } from "react";
import { ChooseProjectScreen, Modal } from "djinn-components";
import { useNavigate } from "react-router-dom";
import { SiteType } from "../types/api";
import AdminAccountLayout from "../components/Layouts/Account";
import { createDocsUrl, imagePath } from "../utils/urls";
import CreateSiteForm from "../components/Forms/CreateSiteForm";

const AdminDashboard: React.FC = () => {
  const navigate = useNavigate();
  const [sites, setSites] = useState<SiteType[]>([]);
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);

  useEffect(() => {
    getSites();
  }, []);

  const getSites = async () => {
    try {
      const { data } = await axios.get("sites");
      setSites(data as SiteType[]);
    } catch (error) {}
    setLoading(false);
  };

  return (
    <>
      <AdminAccountLayout title="Choose or Create Project">
        <ChooseProjectScreen
          projects={sites.map((site) => ({
            id: site.id,
            icon: imagePath(site.favicon),
            title: site.title,
            url:
              site.custom_domain && site.custom_domain !== ""
                ? site.custom_domain
                : createDocsUrl(site),
          }))}
          loadingProjects={loading}
          chooseProject={(id) => {
            navigate(`/${id}`);
          }}
          canCreate
          createClick={() => setShowCreate(true)}
        />
        <Modal
          shown={showCreate}
          onClose={() => setShowCreate(false)}
          dismissible={true}
          contentSize="max-w-xl"
        >
          <CreateSiteForm />
        </Modal>
      </AdminAccountLayout>
    </>
  );
};

export default AdminDashboard;
